import {Component, Input, OnInit} from '@angular/core';

export type JdAlertType = 'success' | 'warn' | 'info' | 'error';

@Component({
  selector: 'jd-alert',
  template: `
    <div class="jd-alert-header">
      <span *ngIf="jdShowIcon" class="icon">
        <span *ngIf="jdAlertType === 'success'">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0zm0 0h24v24H0V0z"/><path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>
        </span>
        <span *ngIf="jdAlertType === 'warn'">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
        </span>
        <span *ngIf="jdAlertType === 'info'">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
        </span>
        <span *ngIf="jdAlertType === 'error'">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
        </span>
      </span>  
      <span [class.title]="jdTitle" [class.desc]="jdDesc">{{jdTitle}}</span>
    </div> 
    <div class="jd-alert-body">
      <ng-content></ng-content>
      {{jdDesc && jdDesc !== true ? jdDesc : ''}}
    </div>
  `,
  styles: [],
  host: {
    '[class.jd-alert-success]' :    "jdAlertType === 'success'",
    '[class.jd-alert-warn]' :    "jdAlertType === 'warn'",
    '[class.jd-alert-info]' :    "jdAlertType === 'info'",
    '[class.jd-alert-error]' :    "jdAlertType === 'error'",
    '[class.cf]' :    "true",
    '[class.jd-desc]' :    "!jdDesc",
  }
})
export class AlertComponent implements OnInit {

  // alert ç±»å
  @Input() jdAlertType: JdAlertType = 'success';

  // æ¯å¦æ¾ç¤ºICON
  @Input() jdShowIcon = false;

  @Input() jdTitle = '';

  @Input() jdDesc: boolean | string = '';

  constructor() {
  }

  ngOnInit() {
  }

}
